import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';
import { AuthenticationStateService } from '@quorum/authentication/services';
import * as PowerlaneAnalyticsActions from './powerlane-analytics.actions';
import {
  WorkOrdersEntityActionTypes,
  CreateWorkOrderOnServerSuccess,
  AppointmentsEntityActionTypes,
  CreateAppointmentOnServerSuccess,
} from '@quorum/sha-entities/fixed-operations';
@Injectable()
export class PowerLaneEntityEffects {
  CreateAppointmentSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppointmentsEntityActionTypes.CreateAppointmentOnServerSuccess),
      fetch({
        run: (action: CreateAppointmentOnServerSuccess) => {
          return PowerlaneAnalyticsActions.AppointmentCreatedFromPowerLane({ appointmentId: action.payload.id });
        },

        onError: (action, error) => {
          console.error('Error', error);
          return PowerlaneAnalyticsActions.AnalyticsError({ error });
        },
      })
    )
  );

  CreateWorkOrderSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WorkOrdersEntityActionTypes.CreateWorkOrderOnServerSuccess),
      fetch({
        run: (action: CreateWorkOrderOnServerSuccess) => {
          return PowerlaneAnalyticsActions.WorkOrderCreatedFromPowerLane({ workOrderId: action.payload.id });
        },

        onError: (action, error) => {
          console.error('Error', error);
          return PowerlaneAnalyticsActions.AnalyticsError({ error });
        },
      })
    )
  );

  constructor(private actions$: Actions, private authenticationStateService: AuthenticationStateService) {}
}
